var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 305,
    viewBox: "0 0 1440 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-173.731 0L-173.731 305M-121.12 0L-121.12 305M-68.509 0L-68.509 305M-15.8979 0L-15.8979 305M36.7132 0L36.7132 305M89.3243 0L89.3243 305M141.935 0V305M194.547 0V305M247.158 0V305M299.769 0V305M352.38 0V305M404.991 0V305M457.602 0V305M510.213 0V305M562.824 0V305M615.435 0V305M668.047 0V305M720.658 0V305M773.269 0V305M825.88 0V305M878.491 0V305M931.102 0V305M983.713 0V305M1036.32 0V305M1088.94 0V305M1141.55 0V305M1194.16 0V305M1246.77 0V305M1299.38 0V305M1351.99 0V305M1404.6 0V305M1457.21 0V305M1509.82 0V305M1562.44 0V305M1615.05 0V305M1667 53.2435L-227 53.2434M1667 105.83L-227 105.83M1667 158.416L-227 158.416M1667 211.002L-227 211.002M1667 263.588L-227 263.588",
    stroke: "url(#paint0_linear_654_3219)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_654_3219",
    x1: 720,
    y1: -11.5,
    x2: 720,
    y2: 305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitute);
export default __webpack_public_path__ + "static/media/institute.772e81735f93064fd2780343bc10deb5.svg";
export { ForwardRef as ReactComponent };